import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import {
    SortableContainer,
    SortableElement,
    SortableHandle,
} from 'react-sortable-hoc';

// Move utility
function arrayMove(array, from, to) {
    const slicedArray = array.slice();
    slicedArray.splice(
        to < 0 ? array.length + to : to,
        0,
        slicedArray.splice(from, 1)[0]
    );
    return slicedArray;
}

// Label drag handle
const SortableMultiValueLabel = SortableHandle((props) => {
    const index = props.selectProps.value.findIndex(
        (val) => val.value === props.data.value
    );
    const { uneditableIndexes = [] } = props.selectProps;

    if (uneditableIndexes.includes(index)) {
        return <components.MultiValueLabel {...props} />;
    }

    return <components.MultiValueLabel {...props} />;
});

// Hide remove icon for uneditable
const MultiValueRemove = (props) => {
    const index = props.selectProps.value.findIndex(
        (val) => val.value === props.data.value
    );
    const { uneditableIndexes = [] } = props.selectProps;

    if (uneditableIndexes.includes(index)) {
        return null;
    }

    return <components.MultiValueRemove {...props} />;
};

// Wrap MultiValue with SortableElement
const SortableMultiValue = SortableElement((props) => {
    const onMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const innerProps = { ...props.innerProps, onMouseDown };
    return <components.MultiValue {...props} innerProps={innerProps} />;
});

const SortableSelect = SortableContainer(Select);

export default function MultiSelectSort({
                                            locked = false,
                                            value,
                                            placeholder,
                                            options,
                                            className,
                                            selected, setSelected,
                                            styles,
                                            closeMenuOnSelect = false,
                                            uneditableIndexes = [], // <- passed prop
                                        }) {

    useEffect(() => {
        setSelected(value)
    }, []);

    const onChange = (selectedOptions) => {
        uneditableIndexes.forEach((index) => {
            selectedOptions[index] = selected[index]
        })
        setSelected(selectedOptions);
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (
            uneditableIndexes.includes(oldIndex) ||
            uneditableIndexes.includes(newIndex)
        ) {
            return;
        }

        const newValue = arrayMove(selected, oldIndex, newIndex);
        uneditableIndexes.forEach((index) => {
            newValue[index] = selected[index]
        })
        setSelected(newValue);
    };

    const portalStyles = {
        menuPortal: base => ({
            ...base,
            zIndex: 9999,
        }),
    }

    return (
        <SortableSelect
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            menuPosition="fixed"
            styles={{
                ...portalStyles,
                ...styles,
            }}
            className={className}
            useDragHandle
            axis="xy"
            onSortEnd={onSortEnd}
            distance={4}
            helperClass="sortable-helper"
            getHelperDimensions={({ node }) => node.getBoundingClientRect()}
            isMulti
            isDisabled={locked}
            options={options}
            value={selected}
            onChange={onChange}
            placeholder={placeholder}
            components={{
                MultiValue: SortableMultiValue,
                MultiValueLabel: SortableMultiValueLabel,
                MultiValueRemove: MultiValueRemove,
            }}
            closeMenuOnSelect={closeMenuOnSelect}
            uneditableIndexes={uneditableIndexes} // pass to internal components via selectProps
        />
    );
}
